angular.module('elfium').filter('businessCaseState', ['reportContentService', 'BUSINESS_CASE_STATES',
    function (reportContentService, BUSINESS_CASE_STATES) {
        var that = this;
        return function (reports) {
            var state = '';
            if (reportContentService.isActualLocked(reports)) {
                state = BUSINESS_CASE_STATES.WIN;
            } else if (reportContentService.isActualFilled(reports)) {
                state = BUSINESS_CASE_STATES.ACTIVE;
            } else {
                state = BUSINESS_CASE_STATES.NICE_TO_HAVE;
            }
            return state;
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/businessCase/businessCaseStateFilter.ts